import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Colors, Index, Breakpoints } from '@client/style/Variables';
import LogoWithText from './LogoWithText';
import Functions from '@client/style/Functions';
import { LoginLogoutButton } from '../Auth/LoginLogoutButton';
import { MenuBurger } from './MenuBurger';
import CustomEvents, { Events } from '@client/core/CustomEvents';
import MenuContainer from './MenuContainer';
import SearchInput from './search/SearchInput';
import SearchContainer from './search/SearchContainer';
import Site from '@client/store/Site';

const TopBar = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	margin: 20px 0;
	gap: 10px;
	z-index: ${Index.mainMenuButton};
	display: flex;
	flex-direction: row;
	justify-content: end;

	${Functions.breakpoint(Breakpoints.tablet)} {
		gap: 20px;
	}
`;

const StyledLoginLogoutButton = styled(LoginLogoutButton)<{ $hasStoreModule?: boolean }>`
	position: fixed;
	z-index: ${Index.mainMenuButton};
	bottom: ${props => (props.$hasStoreModule ? '210px' : '22px')};
	left: ${props => (props.$hasStoreModule ? '10px' : '22px')};
	background: transparent;

	${Functions.breakpoint(Breakpoints.tablet)} {
		position: relative;
		bottom: unset;
		left: unset;
	}
`;

export default function Menu({
	onLogoClick,
	specificColor = undefined,
	showLogin = true,
	hasStoreModule = false,
}: {
	onLogoClick?: () => void;
	specificColor?: string;
	showLogin?: boolean;
	hasStoreModule?: boolean;
}) {
	const [navigationToggle, setNavigationToggle] = useState(false);
	const enableSiteSearch = Site.use(data => data.search.enableSiteSearch);

	useEffect(() => {
		const onSamePage = () => {
			setNavigationToggle(false);
		};
		CustomEvents.listen(Events.SAMEPAGE, onSamePage);

		return () => {
			CustomEvents.remove(Events.SAMEPAGE, onSamePage);
		};
	}, []);

	return (
		<>
			<LogoWithText
				color={!navigationToggle && specificColor ? specificColor : Colors.defaultWhite}
				onClick={onLogoClick}
			/>
			<TopBar>
				{showLogin && <StyledLoginLogoutButton $hasStoreModule={hasStoreModule} />}

				{enableSiteSearch && (
					<SearchInput color={!navigationToggle && specificColor ? specificColor : Colors.defaultWhite} />
				)}
				<MenuBurger
					color={!navigationToggle && specificColor ? specificColor : Colors.defaultWhite}
					open={navigationToggle}
					toggleOpen={() => {
						setNavigationToggle(!navigationToggle);
					}}
				/>
			</TopBar>

			<MenuContainer isOpen={navigationToggle} />
			{enableSiteSearch && <SearchContainer />}
		</>
	);
}
